/**
 * roleFilter.js
 *
 * Defines available user role options for use in filter dropdowns.
 * Used to filter data by the user's job title or professional role.
 */

export default [
  'Account Associate/Manager',
  'Administrator',
  'Associate',
  'Business Development Manager',
  'Change Manager',
  'Communications Officer / Manager',
  'Finance Officer / Manager',
  'General Manager',
  'HR Officer / Manager',
  'Operations Officer / Manager',
  'Project Coordinator / Manager',
  'Sales / Marketing Manager',
  'Service Manager',
  'Supervisor / Team Leader',
  'Accountant',
  'Analyst',
  'Audit Manager',
  'Banking / Finance Professional',
  'BPO Professional',
  'Consultant',
  'Coordinator',
  'Reports Developer',
  'Risk & Compliance Officer / Manager',
  'Chairperson',
  'Chief Operations Officer',
  'Chief Technology Officer',
  'Director',
  'Founder / Co - Founder',
  'President / CEO',
  'Vice President',
  'Dean',
  'Department Chair',
  'Instructor',
  'Principal',
  'Professor',
  'Program / Learning Coordinator',
  'Training Officer / Manager',
  'Anti-Malware Specialist / Analyst',
  'Forensics Specialist / Analyst',
  'Information Security Professional',
  'Network Security Professional',
  'Security Administrator',
  'Security Analyst / Consultant',
  'Threat Analyst / Researcher',
  'Computer Operator',
  'IT Engineer / Staff',
  'Information Systems Analyst / Officer',
  'IT Officer / Administrator',
  'Service / Helpdesk Staff',
  'System Administrator',
  'Technical Support Staff',
  'Content Creator / Developer',
  'Database Administrator',
  'Database Analyst / Consultant',
  'Graphic Designer / Artist',
  'IT Research and Development Specialist',
  'Network Administrator',
  'Network Analyst / Engineer',
  'Artist',
  'Athlete',
  'Chef / Culinary Specialist',
  'Scientist / Inventor',
  'Editor / Publisher',
  'Engineer / Mechanic / Technician',
  'Entrepreneur / Business Owner / Investor',
  'Medical Doctor / Professional',
  'Police / Military Officer',
  'Writer / Journalist',
  'Developer / Programmer',
  'Software Engineer',
  'QA / Software Testing Analyst / Engineer',
  'Solution Architect',
  'Website Designer',
  'Undergraduate',
  'Postgraduate',
  'Others',
];
